import { RhcField } from 'features/generator/components/RhcField'
import { useSetAtom } from 'jotai'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'

import { TVideo, TVideoFields } from '../VideoFormModel'
import { videoListAtom } from './VideoDetailsFields'

export const VideoDescriptionField = ({
	index,
	videoList,
}: {
	index: number
	videoList: TVideo[]
}) => {
	const t = useTranslations()
	const form = useFormContext<TVideoFields>()

	const setVideoList = useSetAtom(videoListAtom)

	const setValue = (value?: string) => {
		if (value !== undefined) {
			setVideoList((prev) => {
				const newValue = [...prev]
				newValue[index]!.video.description = value
				return newValue
			})
		}
	}

	return (
		<RhcField
			type="text"
			form={form}
			path={`videos.${index}.video.description`}
			error={
				form.formState.errors.videos?.[index]?.video?.description
					?.message
			}
			value={videoList[index]!.video.description}
			setValue={setValue}
			fieldName="video_description"
			fieldGroup="videos"
			label={t(
				'generator__content_form_section__videos_information__description__label',
			)}
			placeholder={t(
				'generator__content_form_section__videos_information__description__placeholder',
			)}
			className="grow tablet:w-full"
		/>
	)
}
